module.exports = __webpack_public_path__ + "static/media/tl.0041b17f.svg";